export default [
    {
        title: "tour.welcomeTitleOne",
        body: "tour.welcomeBodyOne",
        position: "absolute",
        top: 38,
        left: 35,
        ctaText: "tour.welcomeNext",
        first: true,
        id: "Tour_Welcome_Next",
        index: 0
    },
    {
        title: "tour.welcomeTitleTwo",
        body: "tour.welcomeBodyTwo",
        outlineLeft: true,
        position: "absolute",
        top: 38,
        left: 35,
        ctaText: "tour.welcomeNext",
        dialog: true,
        infoIcon: true,
        id: "Tour_InfoActions_Next",
        index: 1
    },
    {
        title: "tour.welcomeTitleThree",
        body: "tour.welcomeBodyThree",
        outlineLeft: true,
        position: "absolute",
        top: 38,
        left: 35,
        ctaText: "tour.welcomeNext",
        dialog: true,
        dialogPlus: true,
        id: "Tour_InteractiveActions_Next",
        index: 2
    },
    {
        title: "tour.welcomeTitleFour",
        body: "tour.welcomeBodyFour",
        outlineLeft: true,
        position: "absolute",
        top: 38,
        left: 35,
        ctaText: "tour.welcomeNext",
        dialog: true,
        play: true,
        id: "Tour_VideoActions_Next",
        index: 3
    },
    {
        title: "tour.welcomeTitleFive",
        body: "tour.welcomeBodyFive",
        outlineLeft: true,
        position: "absolute",
        top: 38,
        left: 35,
        ctaText: "tour.welcomeNext",
        tooltip: true,
        id: "Tour_Navigation_Next",
        index: 4
    },
    {
        title: "tour.welcomeTitleSix",
        body: "tour.welcomeBodySix",
        outlineLeft: true,
        position: "absolute",
        top: 17.4,
        right: 1,
        ctaText: "tour.welcomeNext",
        persona: true,
        id: "Tour_Personas_Next",
        index: 5
    },
    {
        title: "tour.welcomeTitleSeven",
        body: "tour.welcomeBodySeven",
        outlineLeft: true,
        position: "absolute",
        top: 47.4,
        right: 1,
        ctaText: "tour.welcomeStart",
        copy: true,
        id: "Tour_TabOverview_Next",
        index: 6
    }
]